<template>
  <ContainerBox title="视频动画">
    <div class="video-info">
      <Swiper class="swiper" ref="swiperTop" :options="this.swiperOptions" @slideChange="slideTopChange">
        <template v-for="(key, index) in Object.keys(dataSource)">
          <SwiperSlide
            class="swiper-slide"
            :zoom="true"
            :key="key"
            v-if="dataSource[key].source.hasValue && dataSource[key].source.value"
          >
            <div class="swiper-slider-content-wrapper">
              <video
                :id="'video-' + index"
                :src="dataSource[key].source.value"
                controls
                @play="handlePlay(index)"
                @pause="handlePause(index)"
                @ended="handleEnded(index)"
              />
              <div v-if="playIndex !== index" class="play-icon" @click="handlePlay(index)"></div>
            </div>
          </SwiperSlide>
        </template>
      </Swiper>
      <div class="thumbs">
        <Swiper class="swiper-thumbs" ref="swiperThumbs" :options="this.swiperOptionThumbs">
          <template v-for="(key, index) in Object.keys(dataSource)">
            <SwiperSlide
              class="swiper-slide"
              :zoom="true"
              :key="index"
              v-if="dataSource[key].source.hasValue && dataSource[key].source.value"
            >
              <video :src="dataSource[key].source.value" />
            </SwiperSlide>
          </template>
        </Swiper>
      </div>
    </div>
  </ContainerBox>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import ContainerBox from "./containerBox.vue";

export default {
  name: "VideoInfo",
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: { ContainerBox, Swiper, SwiperSlide },
  data() {
    return {
      swiperOptions: {
        // initialSlide: 0,
        spaceBetween: 10,
        navigation: {
          nextEl: `.swiper-navigation .swiper-button-next`,
          prevEl: `.swiper-navigation .swiper-button-prev`
        },
        pagination: {
          el: `.swiper-pagination`
        }
      },
      swiperOptionThumbs: {
        slidesPerView: "auto",
        slideToClickedSlide: true,
        centeredSlides: true,
        navigation: {
          nextEl: ".swiper-thumbs-next",
          prevEl: ".swiper-thumbs-prev"
        }
      },
      playIndex: -1,
      activeIndex: 0
    };
  },
  mounted() {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.$swiper;
      const swiperThumbs = this.$refs.swiperThumbs.$swiper;
      // swiperThumbs.thumbs.swiper = swiperTop
      swiperTop.controller.control = swiperThumbs;
      swiperThumbs.controller.control = swiperTop;
    });
  },
  methods: {
    handlePlay(index) {
      this.playIndex = index;
      const video = document.getElementById(`video-${this.playIndex}`);
      if (video) {
        video.play();
      }
    },
    handlePause() {
      this.playIndex = -1;
    },
    handleEnded() {
      this.playIndex = -1;
    },
    slideTopChange() {
      const swiperTop = this.$refs.swiperTop.$swiper;

      this.activeIndex = swiperTop.activeIndex;
      // 其他的视频停止播放
      const videos = document.querySelectorAll(".video-info video");
      for (let i = 0; i < videos.length; i++) {
        videos[i].pause();
      }
      // 播放
      this.handlePlay(this.activeIndex);
    }
  }
};
</script>

<style lang="less" scoped>
.video-info {
  width: 100%;
  background: #45474a;
  .swiper {
    .swiper-slide {
      width: 100%;
      height: 327px;
      .swiper-slider-content-wrapper {
        video {
          width: 100%;
          height: 327px;
          object-fit: contain;
          background: #e3e3e3;
        }
        .play-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 50%;
          left: 50%;
          z-index: 1;
          transform: translate(-50%, -50%);
          width: 115px;
          height: 115px;
          background: rgba(0, 0, 0, 0.65);
          border-radius: 50%;
          cursor: pointer;
          &::after {
            content: "";
            display: block;
            width: 0;
            height: 0;
            border-top: 20px solid transparent;
            border-bottom: 20px solid transparent;
            border-left: 30px solid #fff;
            margin-left: 10px;
          }
        }
      }
    }
  }

  /deep/ .swiper-thumbs {
    .swiper-wrapper {
      margin-left: -200px;
    }
    .swiper-slide {
      width: 153px;
      height: 86px;
      border-radius: 4px 4px 4px 4px;
      margin: 8px;
      video {
        width: 100%;
        height: 100%;
        object-fit: cover;
        background: #e3e3e3;
        border-radius: 4px;
      }
      &.swiper-slide-active {
        border: 2px solid #5db3e6;
      }
    }
  }
}
</style>
